import { fetcher } from '@commenda/utils';

import { TUpsertBillingPlanParams } from './types';

export const upsertBillingPlan = async (params: TUpsertBillingPlanParams) => {
  const { plan, ...body } = params;
  const response = await fetcher(`commenda-billing/catalog/plans/${plan}`, {
    method: 'PUT',
    body,
  });

  return response;
};
